import React from 'react';


const Topbar = () => {
  return (
    <div className="container-fluid topbar d-none d-xl-block w-100">
      <div className="row gx-0 align-items-center" style={{ height: '45px' }}>
        {/* Left Side Info */}
        <div className="col-lg-6 text-center text-lg-start mb-lg-0">
          <div className="d-flex flex-wrap">
            <a href="#" className="text-muted me-4">
              <i className="fas fa-map-marker-alt text-secondary me-2"></i>
              Find A Location
            </a>
            <a href="#" className="text-muted me-4">
              <i className="fas fa-phone-alt text-secondary me-2"></i>
              +01234567890
            </a>
            <a href="#" className="text-muted me-0">
              <i className="fas fa-envelope text-secondary me-2"></i>
              Example@gmail.com
            </a>
          </div>
        </div>

        {/* Right Side Info */}
        <div className="col-lg-6 text-center text-lg-end">
          <div className="d-flex align-items-center justify-content-end">
            <a href="#" className="text-muted me-3">
              <i className="fas fa-clock text-secondary me-2"></i>
              Mon - Sat 8:00 - 17:30, Sunday - CLOSED
            </a>
            <a href="#" className="btn btn-primary btn-square border border-white me-3">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="btn btn-primary btn-square border border-white me-3">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="btn btn-primary btn-square border border-white me-3">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="btn btn-primary btn-square border border-white me-3">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
